export default __webpack_public_path__ + "static/media/cp_geo_pt.645059c5.svg";